/**
 * @prettier
 */

import _has from 'lodash/has';

// eslint-disable-next-line import/prefer-default-export
export const isCustomizationActive = customization =>
  _has(customization, 'inactive') ? !customization.inactive : !customization.deleted_at;



// WEBPACK FOOTER //
// ./src/cards/util/isCustomizationActive.js